import dayjs from "dayjs";
import ApiCall from "utils/ApiCall";

// const route = `${process.env.REACT_APP_API}/api/users`;

const getBookingByBookingNumber = async (bookingNumber: string) => {
  try {
    const route = `${process.env.REACT_APP_API}/bookings?bookingNumber=${bookingNumber}`
    // console.log("calling to api:", route)
    const booking = await ApiCall.get(route);

    // console.log({waitForRoomRecords})

    return booking || null
  } catch (err) {
    console.error("getBookingByBookingNumber err: ",err)
    return {}
    // throw err
  }
};

const updateGuestProfile = async (data: any) => {
  try {
    // console.log(data)
    // if (!data._id)
    //   return await createPrearrival(data)

    await ApiCall.replace(
      `${process.env.REACT_APP_API}/bookings/guestprofiles`,
      data,
    );

    // await ApiCall.replace(
    //   `${process.env.REACT_APP_API}/prearrivals/${data.id}`,
    //   data,
    // );
  } catch (err) {
    throw err
  }
};

export {
  getBookingByBookingNumber,
  updateGuestProfile,
};
